import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentDocumentLink } from 'src/app/models/content-document-link.model';

import { api } from '../../../models/api-url.model';
import { ApiService } from '../api';

export interface FileAPI {
  binaryData: ArrayBuffer;
  blob?: Blob;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private readonly apiService = inject(ApiService);

  getServiceOrderFormFiles(): Observable<ContentDocumentLink[]> {
    return this.apiService.get(api.sofAttachmentURL);
  }

  getInvoiceFiles(): Observable<ContentDocumentLink[]> {
    return this.apiService.get(api.invoiceAttachmentURL);
  }

  addAttachment(formData: FormData): Observable<{ message: string }> {
    return this.apiService.post(api.attachmentURL, formData);
  }

  getInvoiceBlob(file: ContentDocumentLink): Observable<FileAPI> {
    return this.apiService
      .get(
        `${api.invoiceAttachmentURL}/${file.ContentDocument.LatestPublishedVersionId}`,
        { responseType: 'arraybuffer' },
      )
      .pipe(
        map((data) => {
          const newBlob = new Blob([data], {
            type: `${file.ContentDocument.FileExtension}`,
          });
          const url = window.URL.createObjectURL(newBlob);
          return { binaryData: data, url };
        }),
      );
  }

  getSOFBlob(file: ContentDocumentLink, orderId: string): Observable<FileAPI> {
    return this.apiService
      .get(
        `${api.ordersURL}/${orderId}${api.attachmentURL}/${file.ContentDocument.LatestPublishedVersionId}`,
        { responseType: 'arraybuffer' },
      )
      .pipe(
        map((data) => {
          const newBlob = new Blob([data], {
            type: `${file.ContentDocument.FileExtension}`,
          });
          const url = window.URL.createObjectURL(newBlob);
          return { binaryData: data, url };
        }),
      );
  }
}
